// extracted by mini-css-extract-plugin
export default {"label":"PctJIe0HvupEuC1HlLq6","item":"CRy0XUM3MdM6Ys70OwOG"};